import type { PaginatedResponse, TestRunListItem, TestRunListQuery, TestRunSummary } from '@analyzer/client';
import { useQuery } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';

export function useTestRunListQuery(queryParams: TestRunListQuery) {
  const client = useService();
  return useQuery<PaginatedResponse<TestRunListItem>, Error>(
    ['test-run-list', queryParams],
    () => client.testRunList(queryParams),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  );
}

export function useTestRunSummaryQuery(queryParams: TestRunListQuery) {
  const client = useService();
  return useQuery<TestRunSummary, Error>(
    ['test-run-summary', queryParams],
    () => client.testRunSummary(queryParams),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  );
}

export function useTestRunReadQuery(runId: string | null) {
  const client = useService();
  return useQuery<TestRunListItem, Error>({
    queryKey: ['test-run-read', runId],
    queryFn: () => client.testRunRead(runId!),
    enabled: runId !== null
  });
}
